import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FadeInSection from '@/components/base/FadeInSection';
import HeroSection from './components/HeroSection';
import FeaturedWorks from './components/FeaturedWorks';
import CategoryShowcase from './components/CategoryShowcase';
import MembershipPlans from './components/MembershipPlans';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FadeInSection><FeaturedWorks /></FadeInSection>
        <FadeInSection delay={100}><CategoryShowcase /></FadeInSection>
        <FadeInSection delay={100}><MembershipPlans /></FadeInSection>
        <FadeInSection delay={100}><CTASection /></FadeInSection>
        <FadeInSection delay={100}><FAQSection /></FadeInSection>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '麻豆传媒',
            url: 'https://madoumedia.com/',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://madoumedia.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '麻豆传媒官方落地页',
            description:
              '麻豆传媒是专注优质影视内容制作与发行的专业传媒机构，提供正版高清影视资源、原创剧情内容及多元娱乐体验。',
            url: 'https://madoumedia.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '麻豆传媒',
              url: 'https://madoumedia.com/',
            },
          }),
        }}
      />
    </>
  );
}